<ng-container *ngIf="wallet">
  <section class="checkout__container flex flex-col gap-4">
    <ng-container *ngIf="hasTrial">
      <p [style.fontWeight]="500">Free trial</p>
      <div class="item">
        <span>Trial {{ productName }} for free</span>
        <mat-slide-toggle checked (toggleChange)="toggleTrial()"></mat-slide-toggle>
      </div>
    </ng-container>
    <p [style.fontWeight]="500">Auto-renew option</p>
    <div class="item">
      <span>Automatically renew your subscription <strong>07</strong> days before the expiry date.</span>
      <mat-slide-toggle [(ngModel)]="autoRenew" (ngModelChange)="changeRenew()"></mat-slide-toggle>
    </div>
    <p [style.fontWeight]="500">Payment summary</p>
    <div>
      <div class="flex flex-col w-full">
        <div class="item no-border-bottom flex justify-between" *ngIf="!hasNumber">
          <span>Number of subscriptions</span>
          <mat-form-field appearance="outline">
            <mat-label>Quantity</mat-label>
            <input matInput type="number" inputNumberKeydown [(ngModel)]="quantity" (change)="onQuantityChange()" />
          </mat-form-field>
        </div>
        <div class="item no-border-bottom flex justify-between" *ngIf="hasNumber">
          <span>Number activation fee</span>
          <span class="highlight item__pricing">{{ totalActivationFee | currency: wallet?.currency }}</span>
        </div>
        <div class="item no-border-bottom flex justify-between">
          <span>Total price</span>
          <span class="highlight item__pricing">{{ totalPrice | currency: wallet?.currency }}</span>
        </div>
        <div class="item no-border-bottom flex justify-between">
          <span>Available credits </span>
          <span class="highlight item__available">{{ wallet.usableCredit | currency: wallet?.currency }}</span>
        </div>
        <div class="item flex justify-between">
          <span> Credit after purchase </span>
          <span class="highlight item__remaining">{{
            wallet.usableCredit - totalPrice | currency: wallet?.currency
          }}</span>
        </div>
      </div>
    </div>
  </section>
</ng-container>
